import React from "react";
import { Container, Box } from "@mui/material";

const Loading = () => {
  return (
    <Container
      maxWidth="sm"
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        <img
          src="/images/loading.png"
          style={{ maxWidth: "30%", borderRadius: "10px" }}
          alt="loading"
        />
      </Box>
    </Container>
  );
};

export default Loading;
